/**
 * model for a generic map of one data type
 */
export interface Dictionary<T> {
  [name: string]: T;
}
